module.exports = __webpack_public_path__ + "static/media/bank_nyyh.39fdb9f9.png";